import * as React from "react";
import {Fragment} from "react";
import {withRouter} from "react-router-dom";

const IMAGE_LOCATION = "./mobile_images/";
const TUTORIAL_MAP = {
    "1": "Ria_Sikhona_Mobile_App_Quick_Guide_screen_01.png",
    "2": "Ria_Sikhona_Mobile_App_Quick_Guide_screen_02.png",
    "3": "Ria_Sikhona_Mobile_App_Quick_Guide_screen_03.png",
    "4": "Ria_Sikhona_Mobile_App_Quick_Guide_screen_04.png"
};

class Tutorial extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentWizard: 1
        }
    }

    componentDidMount() {

        if (this.props.setHeader)
            this.props.setHeader("")
    }

    nextPage() {
        if (this.state.currentWizard < 4) {
            this.setState({
                currentWizard: this.state.currentWizard + 1
            })
        } else {
            this.goBackHome();
        }
    }

    previousPage() {
        this.setState({
            currentWizard: this.state.currentWizard - 1
        })
    }

    goBackHome() {
        this.props.history.replace("/home")
    }

    cacheImages() {

        return <div style={{
            position: "absolute",
            left: "-100000px",
            width: "1px",
            height: "1px"
        }}>
            {
                Object.keys(TUTORIAL_MAP).map((number, index) => {
                    return <img key={index} src={IMAGE_LOCATION + TUTORIAL_MAP[number]} alt={""}/>
                })
            }
        </div>

    }

    render() {
        return <Fragment>
            {this.cacheImages()}
            <div className={this.props.isMobile ? "tutorial_screen_div" : "browser_tutorial_screen_div"}>
                <div style={{display: "flex", alignItems: "center", justifyContent: "flex-end", height: "5%"}}>
                    <div style={{color: "var(--riaNavyBlue)", fontWeight: "bold", marginRight: "20px"}}
                         onClick={() => this.goBackHome()}>SKIP
                    </div>
                </div>
                {this.renderWizardPages()}
                <div style={{display: "flex", alignItems: "center", justifyContent: "space-around", height: "10%"}}>
                    {this.state.currentWizard !== 1
                        ? <div style={{color: "var(--riaNavyBlue)", fontSize: "24px"}} className={"fa fa-arrow-left"}
                               onClick={() => this.previousPage()}/>
                        : <div style={{color: "var(--riaNavyBlue)", fontSize: "24px", opacity: 0}} className={"fa fa-arrow-left"}/>
                    }
                    <div>
                        {
                            [1, 2, 3, 4].map(number => {
                                return <Fragment key={number}>{this.state.currentWizard === number
                                    ? <div className={"fa fa-circle"} style={{color: "var(--riaNavyBlue)"}}/>
                                    : <div className={"fa fa-circle-thin"} style={{color: "var(--riaNavyBlue)"}}/>
                                }
                                    {'    '}
                                </Fragment>
                            })
                        }
                    </div>
                    <div style={{color: "var(--riaNavyBlue)", fontSize: "24px"}} className={"fa fa-arrow-right"}
                         onClick={() => this.nextPage()}/>
                </div>
            </div>

        </Fragment>

    }

    renderWizardPages() {
        let src = IMAGE_LOCATION + TUTORIAL_MAP[this.state.currentWizard];
        return <img className={"tutorial_screen"} src={src} alt=""/>
    }

}

export default withRouter(Tutorial);